import { render, staticRenderFns } from "./RestartAppActions.vue?vue&type=template&id=896ce028&scoped=true&"
import script from "./RestartAppActions.vue?vue&type=script&lang=js&"
export * from "./RestartAppActions.vue?vue&type=script&lang=js&"
import style0 from "./RestartAppActions.vue?vue&type=style&index=0&id=896ce028&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896ce028",
  null
  
)

export default component.exports